// extracted by mini-css-extract-plugin
export default {"modelTab":"VQ7GExu","tabButton":"jP6hrIX","active":"qo5RtYf","panel":"QcnvWlG"};